;
define("store_locator_list_all_store.tpl", function(){});

